/**
 * 系统错误码 — 跨业务复用的闭集
 *
 * 与 dev-docs `01-通用约定/20-错误码字典.md` §1.1 系统码保持完全一致
 * （admin-api 与 C 端 API 共享同一套系统码格式，便于前端复用统一拦截器）
 *
 * 格式：UPPER_SNAKE_CASE
 */

export const SYSTEM_ERROR_CODES = {
  OK: 'OK',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  BAD_REQUEST: 'BAD_REQUEST',
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  AUTH_INVALID: 'AUTH_INVALID',
  FORBIDDEN_OPERATION: 'FORBIDDEN_OPERATION',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  RESOURCE_CONFLICT: 'RESOURCE_CONFLICT',
  RATE_LIMITED: 'RATE_LIMITED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
} as const;

export type SystemErrorCode = (typeof SYSTEM_ERROR_CODES)[keyof typeof SYSTEM_ERROR_CODES];
